/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Panel } from 'primereact/panel';
import { injectIntl, defineMessages } from 'react-intl';
import SurveySubRespondents from './SurveySubRespondents';
import SurveyRespondentsHeader from './SurveyRespondentsHeader';
import ArrayUtil from '../../../utils/ArrayUtil';
import { growlErrors, growlActionSuccess } from '../../../utils/NotificationUtil';
import { searchRespondents } from '../../../services/apps/RespondentServices';
import { getRespondentOfSurveys } from '../../../utils/SurveyUtil';
import SurveySelfRespondents from './SurveySelfRespondents';
import { matchShape, growlShape, intlShape } from '../../../components/prop-types';
import { withGrowl } from '../../../components/GrowlNotifications';
import { updateSurveyRespondent } from '../../../services/apps/SurveyService';
import { withAccount } from '../../../components/AccountContext';

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset('surveyDetailEdit')),
  changeForm: (type, respondents) => dispatch(change('surveyDetailEdit', type, respondents.map(r => r.respondent.id))),
});

const listRespondent = (type) => {
  const list = [];
  type.forEach((r) => {
    list.push(r.respondent.id);
  });
  return list;
};

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

class SurveyRespondents extends Component {
  constructor(props) {
    super(props);

    const { survey } = this.props;
    const disablelist = this.handleDisablelist();
    this.state = {
      isEdit: false,
      isSaving: false,
      managers: survey && ArrayUtil.isNotEmpty(survey.managers) ? survey.managers : [],
      peers: survey && ArrayUtil.isNotEmpty(survey.peers) ? survey.peers : [],
      directReports: survey && ArrayUtil.isNotEmpty(survey.directReports) ? survey.directReports : [],
      others: survey && ArrayUtil.isNotEmpty(survey.others) ? survey.others : [],
      respondents: [],
      loadingRes: false,
      disable: disablelist,
    };

    this.handleToggleEdit = this.handleToggleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleSaveEdit = this.handleSaveEdit.bind(this);
    this.handleAddRespondent = this.handleAddRespondent.bind(this);
    this.handleRemoveRespondent = this.handleRemoveRespondent.bind(this);
    this.handleDisablelist = this.handleDisablelist.bind(this);
    this.onChangeRespondentCategory = this.onChangeRespondentCategory.bind(this);
    this.searchRespondent = this.searchRespondent.bind(this);
    this.handleEditRespondents = this.handleEditRespondents.bind(this);
  }

  componentDidMount() {
    this.fetchRespondents();
  }

  componentWillReceiveProps(props) {
    const { survey } = props;
    const { isEdit } = this.state;
    if (survey && isEdit === false) {
      this.setState({
        managers: survey && ArrayUtil.isNotEmpty(survey.managers) ? survey.managers : [],
        peers: survey && ArrayUtil.isNotEmpty(survey.peers) ? survey.peers : [],
        directReports: survey && ArrayUtil.isNotEmpty(survey.directReports) ? survey.directReports : [],
        others: survey && ArrayUtil.isNotEmpty(survey.others) ? survey.others : [],
      });
    }
  }

  onChangeRespondentCategory(respondent, assessmentStatus, oldType, newType) {
    // eslint-disable-next-line react/destructuring-assignment
    const oldRespondentsCategory = this.state[oldType].filter(v => v.respondent.id !== respondent.id);

    // eslint-disable-next-line react/destructuring-assignment
    const newRespondentsCategory = this.state[newType].slice();
    newRespondentsCategory.push({ respondent, status: assessmentStatus });

    const { changeForm } = this.props;
    changeForm(oldType, oldRespondentsCategory);
    changeForm(newType, newRespondentsCategory);

    this.setState({
      [oldType]: oldRespondentsCategory,
      [newType]: newRespondentsCategory,
    });
  }

  searchRespondent(query) {
    this.fetchRespondents(query);
  }

  async fetchRespondents(query) {
    const { match, growl } = this.props;
    this.setState({ loadingRes: true });
    try {
      const { aid } = match.params;
      const respondents = await searchRespondents({
        aid,
        query,
      });

      this.setState({
        respondents,
        loadingRes: false,
      });
    } catch (errors) {
      growlErrors(growl, errors);
      this.setState({ loadingRes: false });
    }
  }

  async handleSaveEdit() {
    const { isSaving } = this.state;

    this.setState({
      isSaving: !isSaving,
    });
  }

  handleDisablelist() {
    const { survey } = this.props;
    const disablelist = [survey.self.respondent.id];
    if (survey && ArrayUtil.isNotEmpty(survey.managers)) {
      disablelist.push(...survey.managers.map(value => value.respondent.id));
    }
    if (survey && ArrayUtil.isNotEmpty(survey.peers)) {
      disablelist.push(...survey.peers.map(value => value.respondent.id));
    }
    if (survey && ArrayUtil.isNotEmpty(survey.directReports)) {
      disablelist.push(...survey.directReports.map(value => value.respondent.id));
    }
    if (survey && ArrayUtil.isNotEmpty(survey.others)) {
      disablelist.push(...survey.others.map(value => value.respondent.id));
    }
    return disablelist;
  }

  handleToggleEdit() {
    const { isEdit } = this.state;
    this.setState({ isEdit: !isEdit });
  }

  resetRespondentList() {
    const { survey } = this.props;
    const disablerefresh = this.handleDisablelist();
    this.setState({
      managers: survey && ArrayUtil.isNotEmpty(survey.managers) ? survey.managers : [],
      peers: survey && ArrayUtil.isNotEmpty(survey.peers) ? survey.peers : [],
      directReports: survey && ArrayUtil.isNotEmpty(survey.directReports) ? survey.directReports : [],
      others: survey && ArrayUtil.isNotEmpty(survey.others) ? survey.others : [],
      disable: disablerefresh,
    });
  }

  handleCancelEdit() {
    const { survey } = this.props;
    const disablerefresh = this.handleDisablelist();
    this.setState({
      managers: survey && ArrayUtil.isNotEmpty(survey.managers) ? survey.managers : [],
      peers: survey && ArrayUtil.isNotEmpty(survey.peers) ? survey.peers : [],
      directReports: survey && ArrayUtil.isNotEmpty(survey.directReports) ? survey.directReports : [],
      others: survey && ArrayUtil.isNotEmpty(survey.others) ? survey.others : [],
      disable: disablerefresh,
    });
    this.handleToggleEdit();
    this.resetRespondentList();
  }

  handleAddRespondent(respondent, type) {
    const { disable } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const respondents = this.state[type].slice();
    respondents.push({ respondent });
    this.setState({ [type]: respondents });
    disable.push(respondent.id);
  }

  handleRemoveRespondent(id, type) {
    const { disable } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const respondents = this.state[type].filter(v => v.respondent.id !== id);
    this.setState({ [type]: respondents });
    const index = disable.indexOf(id);
    disable.splice(index, 1);
  }

  async handleEditRespondents() {
    const {
      match, currentAccount, growl, intl,
    } = this.props;
    const {
      managers, peers, directReports, others,
    } = this.state;
    const { formatMessage } = intl;
    const { surveyId } = match.params;
    const input = {
      surveyId,
      accountId: currentAccount,
      managerIds: managers ? listRespondent(managers) : [],
      peerIds: peers ? listRespondent(peers) : [],
      directReportIds: directReports ? listRespondent(directReports) : [],
      otherIds: others ? listRespondent(others) : [],
    };

    this.handleSaveEdit();

    await updateSurveyRespondent(input).then(() => {
      this.handleSaveEdit();
      this.handleToggleEdit();
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    }).catch((errors) => {
      this.handleSaveEdit();
      growlErrors(growl, errors);
    });
  }

  render() {
    const {
      survey, onChangeCheckedRespondent,
      reportObservers,
    } = this.props;
    const { respondents, loadingRes } = this.state;
    if (!survey) return null;

    const { self } = survey;
    const {
      isEdit, isSaving, managers, peers, directReports, others, disable,
    } = this.state;
    const selectedRespondents = getRespondentOfSurveys({
      self,
      peers,
      managers,
      direct: directReports,
      others,
    });
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Panel>
            <SurveyRespondentsHeader
              isEdit={isEdit}
              isSaving={isSaving}
              toggleEdit={this.handleToggleEdit}
              onEdit={this.handleEditRespondents}
              onCancel={this.handleCancelEdit}
            />
            <SurveySelfRespondents
              isShowTrigger={false}
              self={
                {
                  id: self.id,
                  respondent: self.respondent,
                  status: self.status,
                  startUrl: self.startUrl,
                  previewInviteUrl: self.previewInviteUrl,
                  previewReminderUrl: self.previewReminderUrl,
                }
              }
            />
            <div>
              <SurveySubRespondents
                type="managers"
                self={self}
                subRespondents={managers}
                disable={disable}
                isEdit={isEdit}
                respondentsSearch={this.searchRespondent}
                selectedRespondents={selectedRespondents}
                onAdd={this.handleAddRespondent}
                onRemove={this.handleRemoveRespondent}
                survey={survey}
                processing={loadingRes}
                respondentList={respondents}
                onChangeCheckedRespondent={onChangeCheckedRespondent}
                onChangeRespondentCategory={this.onChangeRespondentCategory}
                reportObservers={reportObservers}
              />

              <SurveySubRespondents
                type="peers"
                subRespondents={peers}
                self={self}
                disable={disable}
                isEdit={isEdit}
                respondentsSearch={this.searchRespondent}
                selectedRespondents={selectedRespondents}
                onAdd={this.handleAddRespondent}
                onRemove={this.handleRemoveRespondent}
                survey={survey}
                processing={loadingRes}
                respondentList={respondents}
                onChangeCheckedRespondent={onChangeCheckedRespondent}
                onChangeRespondentCategory={this.onChangeRespondentCategory}
                reportObservers={reportObservers}
              />

              <SurveySubRespondents
                type="directReports"
                subRespondents={directReports}
                self={self}
                disable={disable}
                isEdit={isEdit}
                respondentsSearch={this.searchRespondent}
                onAdd={this.handleAddRespondent}
                onRemove={this.handleRemoveRespondent}
                selectedRespondents={selectedRespondents}
                survey={survey}
                processing={loadingRes}
                respondentList={respondents}
                onChangeCheckedRespondent={onChangeCheckedRespondent}
                onChangeRespondentCategory={this.onChangeRespondentCategory}
                reportObservers={reportObservers}
              />

              <SurveySubRespondents
                type="others"
                subRespondents={others}
                self={self}
                disable={disable}
                isEdit={isEdit}
                respondentsSearch={this.searchRespondent}
                selectedRespondents={selectedRespondents}
                onAdd={this.handleAddRespondent}
                onRemove={this.handleRemoveRespondent}
                survey={survey}
                processing={loadingRes}
                respondentList={respondents}
                onChangeCheckedRespondent={onChangeCheckedRespondent}
                onChangeRespondentCategory={this.onChangeRespondentCategory}
                reportObservers={reportObservers}
              />
            </div>
          </Panel>
        </div>
      </div>
    );
  }
}

SurveyRespondents.propTypes = {
  survey: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeCheckedRespondent: PropTypes.func.isRequired,
  changeForm: PropTypes.func.isRequired,
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
  intl: intlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  reportObservers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withAccount(
  injectIntl(
    withGrowl(
      connect(
        null,
        mapDispatchToProps,
      )(SurveyRespondents),
    ),
  ),
);
